/**
 * Settare a null nel caso non si voglia testare
 */
export const enableEditorInternalStatusLog = false;

/**
 * Per configurare in ambiente di sviluppo i log dei widget
 * 1. abilitare la stampa dei log
 * 2. inserire in logWidgetsIds gli internalId dei widget da loggare
 */
export const enableWidgetInternalStatusLog = false;
export const logWidgetsIds = [];


// END / WIDGET TEST CONST =========================================
